import React from 'react'
import { Scrollbars } from '@manychat/manyui'

const DEFAULT_ROW_HEIGHT = 20

interface IOptionalScrollProps {
  inputPadding: number
  inputPaddingBottom: number
  maxRows?: number
  multiline?: boolean
  children?: React.ReactNode
}

const OptionalScroll = ({
  children,
  inputPadding,
  inputPaddingBottom = inputPadding,
  maxRows,
  multiline,
}: IOptionalScrollProps) => {
  const content = (
    <div style={{ padding: inputPadding, paddingBottom: inputPaddingBottom }}>{children}</div>
  )
  if (multiline !== false && maxRows) {
    const maxHeight = inputPadding + inputPaddingBottom + maxRows * DEFAULT_ROW_HEIGHT
    return (
      <Scrollbars autoHeight autoHeightMax={`${maxHeight}px`}>
        {content}
      </Scrollbars>
    )
  }
  return content
}

export default OptionalScroll
